import { useQuery } from "@tanstack/react-query";
import { getUserTagsByLegacyIds } from "@/apis/tags/tag-apis";
import type { UserTagWithDetails } from "@/domain/tags";
import { queryKeys } from "./keys";

export function useUserTagsByLegacyIds(legacyIds: string[]) {
  return useQuery({
    queryKey: queryKeys.userTags.byLegacyIds(legacyIds),
    queryFn: async () => {
      const tagsMap = await getUserTagsByLegacyIds(legacyIds);
      const tagsByLegacyId: Record<string, UserTagWithDetails[]> = {};
      for (const [legacyId, tags] of tagsMap.entries()) {
        tagsByLegacyId[legacyId] = tags;
      }
      return tagsByLegacyId;
    },
    enabled: legacyIds.length > 0,
    staleTime: 5 * 60 * 1000,
  });
}
